import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
export const API = `${BACKEND_URL}/api/v1`;

export const fetchProducts = (params = {}) =>
  axios.get(`${API}/products`, { params }).then((r) => normalizeList(r.data));
export const fetchProduct = (slug) => axios.get(`${API}/products/${slug}`).then((r) => normalizeDetail(r.data));
export const fetchCategories = () =>
  axios.get(`${API}/categories`).then((r) => normalizeCategories(r.data));
export const postReview = (slug, data) =>
  axios.post(`${API}/products/${slug}/reviews`, data).then((r) => r.data);
export const createCheckout = (payload) =>
  axios.post(`${API}/payments/checkout`, payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);

const DEFAULT_IMAGE = 'https://images.unsplash.com/photo-1584466977773-e625c37cdd50?auto=format&fit=crop&w=800&q=80';

export const prodImg = (src, w = 800) => {
  if (!src) return DEFAULT_IMAGE;
  if (/^https?:\/\//i.test(src)) return src;
  return `https://images.unsplash.com/photo-${src}?auto=format&fit=crop&w=${w}&q=80`;
};

const normalizeProduct = (p) => ({
  ...p,
  image: p.image ?? null,
  name: p.name ?? '',
  slug: p.slug ?? '',
  category: p.category ?? '',
  short: p.short ?? p.short_description ?? '',
  short_description: p.short_description ?? p.short ?? '',
  badge: p.badge ?? p.tag ?? null,
  tag: p.tag ?? p.badge ?? null,
  rating: p.rating ?? 0,
  reviews_count: p.reviews_count ?? 0,
  price: Number(p.price) || 0,
  moq: p.moq ?? 1,
  wholesale_tiers: Array.isArray(p.wholesale_tiers) ? p.wholesale_tiers : [],
});

const normalizeList = (data) => ({
  products: (data.products || []).map(normalizeProduct),
  categories: data.categories || [],
  meta: data.meta || {},
});

const normalizeDetail = (data) => {
  const payload = data && data.data && data.data.product ? data.data : data;
  return {
    ...payload,
    product: normalizeProduct(payload.product || {}),
    reviews: payload.reviews || [],
    related: (payload.related || []).map(normalizeProduct),
  };
};

const normalizeCategories = (data) => {
  const list = (data && data.data) || data || [];
  const walk = (cats) =>
    (Array.isArray(cats) ? cats : []).map((c) => ({
      ...c,
      id: c.id,
      name: c.name ?? '',
      slug: c.slug ?? '',
      description: c.description ?? '',
      image: c.image ?? null,
      count: c.products_count ?? c.count ?? 0,
      children: walk(c.children),
    }));
  return walk(list);
};

export const fetchSpecialties = () => axios.get(`${API}/specialties`).then((r) => r.data.specialties || []);
export const fetchCategory = (slug) => axios.get(`${API}/categories/${slug}`).then((r) => r.data.data || r.data);
